<div class="driver-details-tooltip">
  <div class="tooltip-head py-spacing-xs px-spacing-md form-label-bg flex align-items-center gap-spacing-2xl justify-content-between">
    @if (driver()?.original_ride_id) {
      <div class="flex gap-spacing-xs align-items-center">
        @if (currentRole != userRole.Client) {
          <div class="ride-id-sec flex align-items-center gap-spacing-2xs">
            <span class="label-medium-medium text-inverse-color">Ride ID</span>
            <span class="label-medium-regular form-border-default-color">#{{ driver()?.original_ride_id }}</span>
          </div>
        }
        <div class="flex align-items-center gap-spacing-2xs">
          <span [class]="'dot block border-circle ' + statusSeverityClass()"></span>
          @if (currentRole == userRole.Client) {
            <span class="label-medium-medium text-inverse-color capitalize">{{ driver()?.ride_status }}</span>
          } @else {
            <span class="label-medium-medium text-inverse-color capitalize">{{ driver()?.ride_attention_status || driver()?.ride_status }}</span>
          }
        </div>
      </div>
    }

    <i
      id="closeBtn"
      (click)="close()"
      (keydown.enter)="close()"
      class="background-surface-base-alpha-10-bg size-icon-md capitalize cursor-pointer text-inverse-color border-round-xs p-spacing-3xs icon-x"></i>
  </div>

  <div class="tooltip-body background-fill-tertiary-bg px-spacing-md py-spacing-xs">
    <div class="item flex flex-column gap-spacing-3xs">
      <span class="label-medium-regular form-border-default-color">Driver</span>
      <span class="label-medium-medium text-inverse-color">{{ driver()?.first_name + " " + driver()?.last_name }}</span>
    </div>
    @if (currentRole == userRole.Client) {
      <div class="item flex flex-column gap-spacing-3xs">
        <span class="label-medium-regular form-border-default-color">Active Students</span>
        <span class="label-medium-medium text-inverse-color">{{ driver()?.active_student_count }}</span>
      </div>
    }

    @if (!driver()?.current_stop_number) {
      <span class="label-medium-regular form-border-default-color">No Active Rides</span>
    }

    @if (driver()?.current_stop_number) {
      <div class="item flex flex-column gap-spacing-3xs current-stop">
        <span class="label-medium-regular form-border-default-color">Current Stop</span>
        <div class="flex justify-content-between align-items-center gap-spacing-2xl py-spacing-2xs">
          <div class="flex gap-spacing-xs align-items-center">
            <span class="current-stop-badge warning label-medium-medium text-inverse-color">
              {{ driver()?.current_stop_number }}
            </span>
            <span class="label-medium-medium text-inverse-color">Stop {{ driver()?.current_stop_number }}</span>
          </div>
          <app-tag
            [content]="currentRole == userRole.Client.toLowerCase() && driver()?.current_stop_status?.toLowerCase() == 'en route' ? 'In Progress' : driver()?.current_stop_status || ''"
            sizeClass="tag-sm"
            styleClass="bold"
            [severityClass]="driver()?.current_stop_status == 'Arrived' ? 'info' : 'warning'">
          </app-tag>
        </div>
      </div>
    }
  </div>
</div>
